import { ComponentProps, ReactElement } from 'react';

import { faMinus } from '@awesome.me/kit-379289146f/icons/classic/solid';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, IconButtonProps, styled } from '@mui/material';

const StyledDiv = styled('div')({
  height: 32,
  width: 32,
  display: 'grid',
  placeItems: 'center',
});

const StyledIconButton = styled(IconButton)(({ disabled }) => ({
  width: 20,
  height: 20,
  border: '2px solid #d82c0d',
  opacity: disabled ? 0.5 : 1,
}));

type RemoveIconButtonProps = {
  ContainerProps?: ComponentProps<'div'>;
  IconProps?: FontAwesomeIconProps;
} & IconButtonProps;

export const RemoveIconButton = ({
  ContainerProps,
  IconProps,
  ...props
}: RemoveIconButtonProps): ReactElement => {
  return (
    <StyledDiv {...ContainerProps}>
      <StyledIconButton {...props}>
        <FontAwesomeIcon
          size="xs"
          icon={faMinus as IconProp}
          {...IconProps}
          style={{ color: '#d82c0d', scale: '80%', ...IconProps?.style }}
        />
      </StyledIconButton>
    </StyledDiv>
  );
};
